<template>
  <div>
    <VTabel
      :height="height"
      :columns="columns"
      :data="dataList"
      :loading="loading"
    ></VTabel>
    <detail-model :show.sync="detail.show" v-bind="detail"></detail-model>
  </div>
</template>

<script>
import api from "../../../../api/request.js";
import Cookies from "js-cookie";
import VTabel from "@/components/components/VTable/index.vue";
import defaultData from "./columns.js";
import DetailModel from "./mods/detail/indev.vue";
const URL = {
  GetCurrRoomAbDevices: "api/CommElecDevice/GetCurrRoomAbDevices", // 告警设备
};
export default {
  components: {
    VTabel,
    DetailModel,
  },
  data() {
    return {
      height: window.innerHeight - 110,
      loading: false,
      dataList: [],
      detail: {
        show: false,
        data: {},
      },
    };
  },
  watch: {
    UseGasState(value) {
      let _this = this;
      if (value) {
        _this.GetCurrRoomAbDevices();
      }
    },
  },
  computed: {
    columns() {
      return defaultData.columns(this);
    },
    UseGasState() {
      let _this = this;
      return _this.$store.getters.getUseGasState;
    },
  },
  mounted() {
    this.GetCurrRoomAbDevices();
  },
  methods: {
    // 获取告警设备列表
    GetCurrRoomAbDevices() {
      const { GroupCode, CompanyCode, DepartmentCode, IsAdmin } = JSON.parse(
        Cookies.get("AdminData")
      );
      api(
        {
          //这里是你自己的请求方式、url和data参数
          method: "get",
          url: `${URL.GetCurrRoomAbDevices}?groupCode=${GroupCode}&companyCode=${CompanyCode}&departmentCode=${DepartmentCode}&isAdmin=${IsAdmin}&deviceType=qg&pageIndex=1&pageSize=1000`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            Authorization: Cookies.get("Token") ? Cookies.get("Token") : "",
          },
        },
        "yhj"
      ).then((res) => {
        this.dataList = res.Data || [];
      });
    },
    // 查看报警
    handleUser(row) {
      this.detail = {
        show: true,
        data: { ...row },
      };
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/useGas/views/alarm/index.vue